__webpack_require__.p = "/bosaapp/";